// Checklist step ids in wizard order
// (see pages/communal/machine/checklist/wizard/Main.tsx and myreportscomm.ChecklistSteps).
export const ChecklistSteps = [
  'visual_inspection',
  'tire_condition',
  'activate',
  'seat_sensor',
  'lamps',
  'driving',
  'hydraulics',
  'soc',
] as const

export type ChecklistStatus = 'success' | 'fail'

export interface ChecklistMachine {
  machineId: string;
  internalNumber?: string;
  manufacturer?: string;
  category?: string;
  model?: string;
}

export interface ChecklistExecution {
  id: string;
  machine: ChecklistMachine;
  createdAt: string;
  status: ChecklistStatus;
  failedStep?: string;
  acceptedSteps: string[];
}

export interface ChecklistFailure {
  failureId: string;
  machine: ChecklistMachine;
  category: string;
  description: string;
  status: string;
  detectionDate?: string;
  createdAt?: string;
}

export interface ChecklistOperatorStat {
  operatorId: string;
  username: string;
  successCount: number;
  failCount: number;
  executions: ChecklistExecution[];
  failures: ChecklistFailure[];
}

export type ChecklistStepState = 'accepted' | 'failed' | 'none'

// A successful checklist has every step accepted, even when acceptedSteps is empty
// or incomplete (e.g. records created before steps were stored).
export const checklistStepState = (execution: ChecklistExecution, step: string): ChecklistStepState => {
  if (execution.status === 'success') {
    return 'accepted'
  }
  if (execution.failedStep === step) {
    return 'failed'
  }
  if (execution.acceptedSteps.includes(step)) {
    return 'accepted'
  }
  return 'none'
}
